/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Template_DescInputs */

const en_analytics_template_desc = /** @type {(inputs: Analytics_Template_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare how different cover letter templates perform.`)
};

const de_analytics_template_desc = /** @type {(inputs: Analytics_Template_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleiche die Leistung verschiedener Anschreiben-Vorlagen.`)
};

const fr_analytics_template_desc = /** @type {(inputs: Analytics_Template_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare les performances de tes différents modèles de lettre de motivation.`)
};

const es_analytics_template_desc = /** @type {(inputs: Analytics_Template_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare el rendimiento de sus diferentes plantillas de carta de presentación.`)
};

const it_analytics_template_desc = /** @type {(inputs: Analytics_Template_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronta le prestazioni dei diversi modelli di lettera di presentazione.`)
};

const nl_analytics_template_desc = /** @type {(inputs: Analytics_Template_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergelijk hoe verschillende motivatiebriefsjablonen presteren.`)
};

const pl_analytics_template_desc = /** @type {(inputs: Analytics_Template_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porównaj skuteczność różnych szablonów listów motywacyjnych.`)
};

const fi_analytics_template_desc = /** @type {(inputs: Analytics_Template_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertaile eri saatekirjemallien suorituskykyä.`)
};

const da_analytics_template_desc = /** @type {(inputs: Analytics_Template_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammenlign, hvordan forskellige ansøgningsbrevskabeloner performer.`)
};

const sv_analytics_template_desc = /** @type {(inputs: Analytics_Template_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jämför hur olika personliga brev-mallar presterar.`)
};

/**
* | output |
* | --- |
* | "Compare how different cover letter templates perform." |
*
* @param {Analytics_Template_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_template_desc = /** @type {((inputs?: Analytics_Template_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Template_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_template_desc(inputs)
	if (locale === "fr") return fr_analytics_template_desc(inputs)
	if (locale === "es") return es_analytics_template_desc(inputs)
	if (locale === "it") return it_analytics_template_desc(inputs)
	if (locale === "nl") return nl_analytics_template_desc(inputs)
	if (locale === "pl") return pl_analytics_template_desc(inputs)
	if (locale === "fi") return fi_analytics_template_desc(inputs)
	if (locale === "da") return da_analytics_template_desc(inputs)
	if (locale === "sv") return sv_analytics_template_desc(inputs)
	return en_analytics_template_desc(inputs)
});